import { OidcAccessToken } from "@axa-fr/react-oidc/dist/ReactOidc";

export interface BackendUserInfo {
  sub: string;
  email: string;
  preferred_username: string;
  name: string;
  given_name: string;
  family_name: string;
  groups: string[];
  available_models: any[];
}

/**
 * Retrieves user information from the backend including groups and available models.
 *
 * @param {OidcAccessToken} accessToken - The access token required to authenticate the user.
 * @return {Promise<BackendUserInfo>} - A promise that resolves to the user information object.
 */
export async function getUserInfo(
  accessToken: OidcAccessToken,
): Promise<BackendUserInfo> {
  const host: string = process.env.REACT_APP_LLMGATEWAY_HOST ?? "";
  const headers: HeadersInit = {
    Authorization: `Bearer ${accessToken.accessToken}`,
    "Content-Type": "application/json",
  };

  let resp = await fetch(`${host}/user/me`, {
    method: "GET",
    headers: headers,
  });

  // Check if the response is successful
  if (!resp.ok) {
    const errorText = await resp.text();
    throw new Error(`HTTP ${resp.status}: ${resp.statusText}${errorText ? ` - ${errorText}` : ''}`);
  }

  return await resp.json();
} 